import React from 'react'
import styled from 'styled-components'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import Link from '@jarvis.oddle/core/components/Link'
import Flex from '@jarvis.oddle/core/components/Flex'
import { SmallText } from '@jarvis.oddle/core/components/Typo'
import UserContext from 'src/containers/UserContext'
import { useRouter } from 'next/router'
import { parseLocale } from '@jarvis.oddle/core/tools/localisation'
import { makeQueryString } from '@jarvis.oddle/core/tools/routes'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

const StyledSmallText = styled(SmallText).attrs((props) => ({
  marginTop: marginSizes.large,
  marginBottom: marginSizes.medium,
  color: props.theme.colorHeadingsFont
}))`
  opacity: 0.6;
`

const SmallLinkText = styled(SmallText).attrs(() => ({
  as: 'span',
  color: 'inherit'
}))`
  text-decoration: underline;
  cursor: pointer;
`
export const UTMSource = {
  SIGNIN_MODAL: 'signinmodal',
  LOYALTY: 'loyalty',
  ACCOUNT_DETAILS: 'accountdetails'
}

const UTMCampaign = {
  OPSG: 'opsg',
  OPTW: 'optw',
  OPMY: 'opmy'
}

const getOddlePassURL = (country, UTMSource, UTMMedium) => {
  let oddlePassUrl
  let queryString = null
  switch (country) {
    case 'SG':
      queryString = makeQueryString({
        utm_campaign: UTMCampaign.OPSG,
        utm_medium: UTMMedium,
        utm_source: UTMSource
      })
      oddlePassUrl = `https://oddle.me/oddlepass/sg${queryString}`
      break
    case 'TW':
      queryString = makeQueryString({
        utm_campaign: UTMCampaign.OPTW,
        utm_medium: UTMMedium,
        utm_source: UTMSource
      })
      oddlePassUrl = `https://oddle.me/oddlepass/tw${queryString}`
      break
    case 'MY':
      queryString = makeQueryString({
        utm_campaign: UTMCampaign.OPMY,
        utm_medium: UTMMedium,
        utm_source: UTMSource
      })
      oddlePassUrl = `https://oddle.me/oddlepass/my${queryString}`
      break
    default:
      oddlePassUrl = '#'
  }
  return oddlePassUrl
}

const PoweredByOddlePass = ({
  className,
  linkHref,
  copyText = 'Learn more about _oddlePassLink_',
  linkText = 'Oddle Pass',
  UTMSource,
  UTMMedium = 'footer'
}: {
  className?: string
  linkHref?: string
  copyText?: string
  linkText?: string
  UTMSource?: string
  UTMMedium?: string
}): JSX.Element => {
  const router = useRouter()
  const { t } = React.useContext(TranslationContext)
  const { isOddlePassEnabled } = React.useContext(UserContext)
  const { locale } = router.query
  const { country } = parseLocale(locale)
  return isOddlePassEnabled ? (
    <Flex justifyContent='center'>
      <StyledSmallText className={className} textAlign='center'>
        {t(copyText, {
          oddlePassLink: (
            <Link
              target='_blank'
              href={linkHref || getOddlePassURL(country, UTMSource, UTMMedium)}
            >
              <SmallLinkText>{linkText}</SmallLinkText>
            </Link>
          )
        })}
      </StyledSmallText>
    </Flex>
  ) : null
}

export default PoweredByOddlePass
